import mixpanel from 'mixpanel-browser'

if (typeof window !== 'undefined') {
  // we have to init regardless of the token being present or not
  // otherwise it'll crash
  mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN ?? 'fakeToken', {
    track_pageview: 'full-url',
    debug: process.env.NODE_ENV === 'development',
    ignore_dnt: true, // Do Not Track
  })
  if (!process.env.NEXT_PUBLIC_MIXPANEL_TOKEN) {
    mixpanel.disable()
  }
}

export const Mixpanel = mixpanel
